<mat-slide-toggle
  [color]="'primary'"
  [ngClass]="customClass"
  [checked]="checked"
  *ngIf="slideControl"
  [formControl]="slideControl"
  [disabled]="!!isDisabled"
  (toggleChange)="toggleChange()"
>
  {{ slideLabel }}
</mat-slide-toggle>
